/**
 * API Configuration for different environments
 * Base URL and timeout settings are configured based on environment variables
 */

// Get base URL based on environment
const getBaseURL = () => {
  // If explicitly set via environment variable, use that
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  
  // Otherwise, use environment-specific URLs
  const env = process.env.REACT_APP_ENV || 'local';
  
  switch (env) {
    case 'production':
    case 'prod':
      return 'https://prod-api.mydatabreachattorney.com/api';
    case 'staging':
    case 'local':
    case 'development':
    default:
      return 'https://staging-api.mydatabreachattorney.com/api';
  }
};

export const API_CONFIG = {
  baseURL: getBaseURL(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};

export const ENVIRONMENT = process.env.REACT_APP_ENV || 'local';

/**
 * Centralized API endpoints for all modules
 */
export const API_ENDPOINTS = {
  // General
  STATUS: '/status',
  HEALTH: '/health',
  PROTECTED: '/protected',

  // Authentication
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    ME: '/auth/me',
    CHANGE_PASSWORD: '/auth/change-password',
    LOGOUT: '/auth/logout',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
  },

  // Users
  USER: {
    LIST: '/users',
    GET_BY_ID: (id: string) => `/users/${id}`,
    CREATE: '/auth/register', // Use auth/register endpoint for user creation
    UPDATE: (id: string) => `/users/${id}`,
    DELETE: (id: string) => `/users/${id}`,
    ACTIVATE: (id: string) => `/users/${id}/activate`,
    DEACTIVATE: (id: string) => `/users/${id}/deactivate`,
    ADMIN_RESET_PASSWORD: (id: string) => `/users/${id}/reset-password`,
  },

  // Campaigns
  CAMPAIGN: {
    LIST: '/campaigns',
    SEARCH: '/campaigns/search',
    GET_BY_ID: (id: string) => `/campaigns/${id}`,
    CREATE: '/campaigns',
    UPDATE: (id: string) => `/campaigns/${id}`,
    DELETE: (id: string) => `/campaigns/${id}`,
    APPROVE: (id: string) => `/campaigns/${id}/approve`,
    REJECT: (id: string) => `/campaigns/${id}/reject`,
    STATS: '/campaigns/stats',
  },

  // Admin — API Key management (JWT-protected, admin only)
  API_KEY: {
    LIST: '/admin/api-keys',
    CREATE: '/admin/api-keys',
    GET_BY_ID: (id: string) => `/admin/api-keys/${id}`,
    UPDATE: (id: string) => `/admin/api-keys/${id}`,
    REVOKE: (id: string) => `/admin/api-keys/${id}/revoke`,
    DELETE: (id: string) => `/admin/api-keys/${id}`,
  },

  // Activities
  ACTIVITY: {
    LIST: '/activities',
    RECENT: '/activities/recent',
    BY_CAMPAIGN: (id: string) => `/activities/campaign/${id}`,
    BY_USER: (id: string) => `/activities/user/${id}`,
    STATS: '/activities/stats',
  },
};

